import React from 'react';
import { makeStyles } from '@material-ui/core';
import { textMedium } from '../../../jss/colors';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#dce1ec',
    height: '54px',
    color: textMedium,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    // textAlign: 'center'
  },
}));

const Footer = (props) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <span>© Copyright 2020 AMERA IoT Inc. - All Rights Reserved</span>
    </div>
  );
};

export default Footer;
